export var typescriptVersion = "3.7.5";
